import { makeAutoObservable } from 'mobx';
import PermissionService from 'services/PermissionService';
import { IPermissions, IPermissionsPayload } from '../interfaces/api/IPermissions';

class PermissionStore {
  permissions: IPermissions = { isSpin3dAllowed: false };

  private permissionService: PermissionService;

  constructor(permissionService: PermissionService) {
    this.permissionService = permissionService;
    makeAutoObservable(this);
  }

  public setPermissions = async (payload: IPermissionsPayload) => {
    this.permissions = await this.permissionService.getPermissions(payload);
  };
}

export default PermissionStore;
